export default __webpack_public_path__ + "static/media/Frostmaim.9ea5e8aa.jpg";